import { render } from "./pre-header-banner.vue?vue&type=template&id=dfdd7caa"
import script from "./pre-header-banner.vue?vue&type=script&lang=js"
export * from "./pre-header-banner.vue?vue&type=script&lang=js"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__